export default {
    ordersPosition: {}
  };